module.exports = __webpack_public_path__ + "img/copyright.1a1be15b.png";